import React from "react";
import { Button, Grid, TextField, Tooltip } from "@material-ui/core";
import { FileCopy } from "@material-ui/icons";
import { useSnackbar } from "components/haven-design/snackbar";

interface Props {
  text: string;
}

const Copyable: React.FC<Props> = ({ text }) => {
  const copy = React.useRef<HTMLInputElement>(null);
  const { openSnackbar } = useSnackbar();
  const copyText = async () => {
    if (copy) {
      copy.current?.select();
    }

    await navigator.clipboard.writeText(text);
    openSnackbar({ message: "Copied!", status: "success" });
  };

  return (
    <Grid container>
      <Grid item xs={9}>
        <Tooltip title="Click to copy">
          <TextField
            variant="outlined"
            size="small"
            inputRef={copy}
            value={text}
            onClick={copyText}
            fullWidth />
        </Tooltip>
      </Grid>
      <Grid item xs={3}>
        <Button
          style={{ marginLeft: 16, marginTop: 2 }}
          color="secondary"
          onClick={copyText}
          variant="outlined"
          startIcon={<FileCopy />}
        >
          Copy
        </Button>
      </Grid>
    </Grid>
  );
};

export default Copyable;
